import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { workoutAPI } from '../services/workoutAPI';

function ConfirmEndProgramModal({ program, onClose, onConfirm }) {
  const [isEnding, setIsEnding] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setError(null);
    setIsEnding(true);

    try {
      await workoutAPI.endProgram(program.id);
      onConfirm(); // Trigger refresh
      onClose();
    } catch (err) {
      console.error('Error ending program:', err);
      setError('Failed to end program. Please try again.');
    } finally {
      setIsEnding(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>End Program?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <p>Are you sure you want to end this program?</p>
        <p className="mb-3">
          <strong>Program:</strong> {program.program_name}
        </p>

        <Alert variant="info">
          <i className="fas fa-info-circle me-2"></i>
          The program will be moved to your completed programs list and will no longer appear here.
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isEnding}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={isEnding}>
          {isEnding ? (
            <>
              <i className="fas fa-spinner fa-spin me-2"></i>
              Ending...
            </>
          ) : (
            'End Program'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmEndProgramModal;
